import type { InfoPageContent } from './infoTypes';

export const aboutContent: InfoPageContent = {
  title: 'About Pilum Trade Lab',
  tagline: 'A no-login, browser-first crypto opportunity terminal that watches public markets and abstains when it has nothing reliable to say.',
  lastUpdated: 'August 7, 2026',
  sections: [
    {
      heading: 'What Pilum Trade Lab is',
      paragraphs: [
        'Pilum Trade Lab is an opportunity filter and research workspace. It watches broad public markets cheaply, detects changing behaviour before a 24-hour leaderboard tells the full story, promotes only a small set of candidates for deeper analysis, and preserves each candidate thesis as conditions evolve.',
        'It is not an instruction to open a trade, not a prediction engine, and not a guarantee of future direction. It is a way to keep hundreds of markets under observation and surface the few that deserve your attention.',
      ],
    },
    {
      heading: 'A product of Pilum Finance',
      paragraphs: [
        'Pilum Trade Lab is a product of Pilum Finance, built in the same browser-first spirit: no login, no cloud account, no exchange keys, and no hidden agenda. The application runs entirely on your device and reads only public market data — that posture is a feature, not a limitation.',
      ],
    },
    {
      heading: 'A reliability-first radar',
      paragraphs: [
        'The radar is deliberately conservative. Unavailable live data stays unavailable — the production path never substitutes simulated opportunities. Deep validation requires real, exchange-confirmed candle history across the selected horizon plus the relevant 1H, 4H, 1D, and 1W hierarchy.',
        'When no candidate passes every evidence, timing, liquidity, and data-quality gate, the Predictor is allowed to stay empty — and the interface says exactly why instead of guessing.',
      ],
    },
    {
      heading: 'Verified market data across venues',
      paragraphs: [
        'Binance spot and perpetual markets form the primary radar, with Bybit and OKX providing independent confirmation and sustaining the lightweight radar when fresh Binance snapshots are unavailable.',
        'Spread inputs use real public order-book data rather than estimates, funding and open interest come from public derivatives feeds, and contract-verified DEX pools are clearly separated from lower-confidence symbol-only results.',
      ],
    },
    {
      heading: 'No login, no secrets, no cloud account',
      paragraphs: [
        'Everything runs in your browser. There is no account system, no wallet connection, no exchange API key, and no hosted database. Candidate history and your filter preferences are stored locally in your own browser and never leave it.',
      ],
    },
    {
      heading: 'The stack',
      bullets: [
        'React 19 and TypeScript with a strict, audited build',
        'A dedicated Web Worker running the whole-market radar over native WebSockets',
        'TradingView Lightweight Charts for fluid candle study',
        'IndexedDB for the local candidate archive',
        'Semantic theme tokens across three built-in themes — Mint Fresh, Navy, and Ocean',
      ],
    },
  ],
};
